export const iconFontAwesomeHumanitarianPlantWilt = (
	<i className="fa-solid fa-plant-wilt"></i>
);
